<template>
  <div>
    <v-container v-show="!showRegister" fluid class="pa-0" justify="center">
      <v-row class="login-container" justify="center">
        <v-col cols="8">
          <div class="p-title">{{ title }}</div>

          <br />

          <v-form>
            <v-row>
              <v-col sm="12">
                <v-text-field
                  label="Correo"
                  prepend-inner-icon="person"
                  autofocus
                  single-line
                  solo
                  required
                  ref="email"
                  :rules="emailRules"
                  v-model="model.email"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col sm="12">
                <v-text-field
                  label="Contraseña"
                  prepend-inner-icon="lock"
                  single-line
                  v-show="inLogin"
                  solo
                  type="password"
                  ref="password"
                  v-model="model.password"
                  @keyup.enter.native="login()"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>

          <div class="flex-grow-1"></div>

          <v-btn
            block
            v-show="inLogin"
            :disabled="isDisabled"
            color="secondary"
            @click="login"
          >
            Continuar
          </v-btn>

          <v-btn
            block
            v-show="!inLogin"
            :disabled="isDisabled"
            color="secondary"
            @click="recoverPassword"
          >
            Enviar correo de recuperación
          </v-btn>

          <br />

          <div class="recover-password" v-show="inLogin">
            ¿Olvidaste tu
            <a @click="showRecover">contraseña</a>?
          </div>

          <div class="recover-password" v-show="inLogin">
            Aún no tienes cuenta con nosotros
            <a @click="register()">registrate aquí.</a>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-show="showRegister">
      <register :sendSnack="snackbar" v-on:backToLogin="register()"> </register>
    </v-container>
  </div>
</template>

<script>
import { events } from "./../../main";
import { formatDate, returnMonthUpdate } from "./../../utils/util";
import register from "./register.vue";

export default {
  name: "login",

  components: {
    register,
  },

  data() {
    return {
      showRegister: false,
      formatDate,
      inLogin: true,
      model: {
        email: "",
        password: "",
      },
      emailRules: [
        (v) => !!v || "El correo es requerido",
        (v) => /.+@.+\..+/.test(v) || "El correo debe ser válido",
      ],
    };
  },

  props: {},

  methods: {
    login() {
      var self = this;
      this.$http.post("login", self.model).then(
        (response) => {
          const lastUpdated = response.body.lastUpdated;
          localStorage.setItem("userId", response.body.userId);
          localStorage.setItem("token", response.body.token);
          localStorage.setItem("name", response.body.name);
          localStorage.setItem(
            "clientId",
            JSON.stringify({
              clientId: response.body.clientId,
            })
          );
          // localStorage.setItem("position", JSON.stringify({ lat: 0, lng: 0 }));
          // if (navigator.geolocation) {
          //   navigator.geolocation.getCurrentPosition(pos => {
          //     localStorage.setItem(
          //       "position",
          //       JSON.stringify({
          //         lat: pos.coords.latitude,
          //         lng: pos.coords.longitude
          //       })
          //     );
          //   });
          // }
          const redirectUrl = self.$route.query.redirect;

          if (
            formatDate(lastUpdated) == returnMonthUpdate(new Date()) ||
            response.body.firstLogin
          ) {
            let isMonthlyUpdate = true;
            redirectUrl
              ? self.$router.push(redirectUrl)
              : self.$router.push({
                  path: `/resetPassword/${isMonthlyUpdate}`,
                });
          } else {
            redirectUrl
              ? self.$router.push(redirectUrl)
              : self.$router.push("/");
          }
        },
        () => {
          this.snackbar("Usuario o Contraseña incorrectos.");
          self.model = {
            email: "",
            password: "",
          };
          self.$refs.email.focus();
        }
      );
    },

    register: function () {
      this.showRegister = !this.showRegister;
    },

    showRecover() {
      this.inLogin = false;
    },

    recoverPassword() {
      this.loading = true;
      var self = this;
      const recoverypasswordPayload = { email: this.model.email };

      console.log("email:", this.model.email);
      this.$http.post("user/recoverypassword", recoverypasswordPayload).then(
        (response) => {
          this.loading = false;

          this.inLogin = true;

          console.log(response);
          this.snackbar(
            "La contraseña ha sido recuperada. Favor de revisar su correo."
          );
        },
        (err) => {
          console.log("Error y el email fue:", this.model.email);
          // console.log(err);

          this.snackbar(
            "El correo electrónico ingresado no existe, favor de verificar."
          );

          self.model = {
            email: "",
          };
          self.$refs.email.focus();

          this.loading = false;
        }
      );
    },

    forgotPassword() {
      this.$router.push("forgotPassword");
    },

    successAlert() {
      this.alert("success", "Mensaje de éxito");
    },

    snackbar(message) {
      events.$emit("snackbar", message);
    },

    alert(alertType, alertMessage) {
      const data = {
        type: alertType,
        message: alertMessage,
      };

      events.$emit("alert", data);
    },
  },

  computed: {
    isDisabled: function () {
      if (this.inLogin) {
        if (
          this.model.email !== "" &&
          this.model.password !== "" &&
          /.+@.+\..+/.test(this.model.email)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        if (this.model.email !== "" && /.+@.+\..+/.test(this.model.email)) {
          return false;
        } else {
          return true;
        }
      }
    },

    title: function () {
      if (this.inLogin) {
        return "Iniciar sesión";
      } else {
        return "Recuperar contraseña";
      }
    },
  },

  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },

  watch: {},

  created() {},

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.login-container {
  height: 100%;
  margin-top: 5%;
  margin-bottom: 5% !important;
}

.login {
  height: 100%;
  padding-left: 5%;
  padding-right: 50%;
}

.logo {
  padding: 2%;
  text-align: left;
}

.p-title {
  font-size: 25px;
  font-weight: 700;
  color: #063c78;
  text-align: left;
}

.v-banner {
  background-image: url("https://images.pexels.com/photos/1054397/pexels-photo-1054397.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-repeat: no-repeat;
  height: 100%;
  background-size: cover;
}

.logo img {
  height: 80px;
  width: auto;
}

.title {
  color: white;
  font-size: 45px;
  margin-top: 50px;
  margin-bottom: 30px;
}

.subtitle {
  font-size: 30px;
  margin-bottom: 60px;
}

.recover-password {
  font-size: 1.6rem;
  text-align: center;
}

.forgot-password .forgot-password-text .btn-forgot-password button {
  background-color: #4b5156;
  color: white;
  margin-left: 0;
  margin-top: 30px;
}

.btn-login {
  text-align: left;
  padding: 0;
}

.btn-login button {
  margin-left: 0;
}
</style>
